import React from 'react';
import styled from 'styled-components/macro';
import { color } from 'styled-system';
import { Input } from '../SubComponents/Inputs';
import { Link, Label } from '../SubComponents/Text';
import { Row } from '../SubComponents/Modals';

const Required = styled(Label)`
  color: ${(props) => props.theme.errorColor};
`;

const TermsContainer = styled.div<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => (props.noMargin ? 0 : '32px')};
  padding: 0 15px;
  ${color}

  @media screen and (max-width: 767px) {
    color: #fff;
    margin-top: 32px;
    margin-bottom: ${(props) => (props.noMargin ? 0 : '16px')};
    padding: 0;
  }
`;

interface TermsProps {
  checked: boolean;
  link?: string | null;
  text: string;
  onChange: (checked: boolean) => void;
  error: boolean;
  noMargin?: boolean;
  textColor?: string;
}

const Terms = (props: TermsProps) => {
  return (
    <TermsContainer noMargin={props.noMargin}>
      <Row justifyContent="center" mb="3">
        <Input
          id="terms"
          type="checkbox"
          checked={props.checked}
          onChange={(event) => props.onChange(event.target.checked)}
          borderRadius="3px"
          error={props.error}
        />
        <Label color={props.textColor} textAlign="center" htmlFor="terms">
          <Link
            href={props.link ?? undefined}
            target="_blank"
            rel="noopener noreferrer"
            ml="2"
            textAlign="center"
            color={props.textColor}
          >
            {props.text}
          </Link>
        </Label>

        <Required ml="1">*</Required>
      </Row>
    </TermsContainer>
  );
};

export default Terms;
